module.exports = __webpack_public_path__ + "static/media/icons.a6aa1126.ai";